"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HorizontalStepperDemo = void 0;
var React = __importStar(require("react"));
var mdbreact_1 = require("@aon/mdbreact");
var Card_1 = require("../Common/Card");
var CardHeader_1 = require("../Common/CardHeader");
var HorizontalStepper_1 = require("./HorizontalStepper");
var items = [
    {
        text: 'Step 1 - Step Name Text for number 1',
        value: 1,
        sequence: 1,
    },
    {
        text: 'Step 2 - Step Name Text for number 2',
        value: 2,
        sequence: 2,
    },
    {
        text: 'Step 3 - Step Name Text for number 3',
        value: 3,
        sequence: 3,
    },
];
var HorizontalStepperDemo = /** @class */ (function (_super) {
    __extends(HorizontalStepperDemo, _super);
    function HorizontalStepperDemo(props) {
        var _this = _super.call(this, props) || this;
        _this.setActiveItem = function (item) {
            _this.setState({ activeItemValue: item.value });
        };
        _this.state = {
            activeItemValue: items[1].value,
        };
        return _this;
    }
    HorizontalStepperDemo.prototype.render = function () {
        return (React.createElement(React.Fragment, null,
            React.createElement("h5", null, "Card header with horizontal stepper"),
            React.createElement(Card_1.Card, null,
                React.createElement(CardHeader_1.CardHeader, { title: 'Header title', size: 'lg', navigation: true },
                    React.createElement(HorizontalStepper_1.HorizontalStepper, { items: items, activeItemValue: this.state.activeItemValue })),
                React.createElement(mdbreact_1.CardBody, null,
                    React.createElement(mdbreact_1.CardText, null, "Some quick example text to build on the card title and make up the bulk of the card's content."))),
            React.createElement("p", { className: 'demo' }, "Example Code"),
            React.createElement("pre", null,
                React.createElement("code", null,
                    "const items: IHorizontalStepperItem[] = [{",
                    React.createElement("br", null),
                    "\u00A0\u00A0text: 'Step 1',",
                    React.createElement("br", null),
                    "\u00A0\u00A0value: 1,",
                    React.createElement("br", null),
                    "\u00A0\u00A0sequence: 1,",
                    React.createElement("br", null),
                    "}, {",
                    React.createElement("br", null),
                    "\u00A0\u00A0text: 'Step 2',",
                    React.createElement("br", null),
                    "\u00A0\u00A0value: 2,",
                    React.createElement("br", null),
                    "\u00A0\u00A0sequence: 2,",
                    React.createElement("br", null),
                    "}, {",
                    React.createElement("br", null),
                    "\u00A0\u00A0text: 'Step 3',",
                    React.createElement("br", null),
                    "\u00A0\u00A0value: 3,",
                    React.createElement("br", null),
                    "\u00A0\u00A0sequence: 3,",
                    React.createElement("br", null),
                    "}];",
                    React.createElement("br", null),
                    React.createElement("br", null),
                    "...",
                    React.createElement("br", null),
                    "this.state = {",
                    React.createElement("br", null),
                    "\u00A0\u00A0activeItemValue: items[1].value,",
                    React.createElement("br", null),
                    "};",
                    React.createElement("br", null),
                    "...",
                    React.createElement("br", null),
                    React.createElement("br", null),
                    "<Card header={true}/>",
                    React.createElement("br", null),
                    "\u00A0\u00A0<CardHeader title='Header title' size='lg' navigation={true}>",
                    React.createElement("br", null),
                    "\u00A0\u00A0\u00A0\u00A0<HorizontalStepper items={items}",
                    React.createElement("br", null),
                    "\u00A0\u00A0\u00A0\u00A0activeItemValues={this.state.activeItemValue}>",
                    React.createElement("br", null),
                    "\u00A0\u00A0</CardHeader>",
                    React.createElement("br", null),
                    "\u00A0\u00A0<CardBody>",
                    React.createElement("br", null),
                    "\u00A0\u00A0\u00A0\u00A0<CardText>Some quick example text to build on the card title and make up the bulk of the card's content.",
                    React.createElement("br", null),
                    "\u00A0\u00A0\u00A0\u00A0</CardText>",
                    React.createElement("br", null),
                    "\u00A0\u00A0</CardBody>",
                    React.createElement("br", null),
                    "</Card> ",
                    React.createElement("br", null),
                    React.createElement("br", null),
                    "Notes: ",
                    React.createElement("br", null),
                    "1. First step is displayed as active by default.",
                    React.createElement("br", null),
                    "2. Always used in a Card with Large size Header, horizontally-centered.",
                    React.createElement("br", null),
                    "3. Can include a max. of 3 steps.",
                    React.createElement("br", null),
                    "4. Need to set the prop of 'navgiation' to true so the alignment is correct.",
                    React.createElement("br", null),
                    "5. Step name has a maximum length of 175px. Longer text will be truncated with ellipsis."))));
    };
    return HorizontalStepperDemo;
}(React.Component));
exports.HorizontalStepperDemo = HorizontalStepperDemo;
